import React from "react";
import "./SelectSticker.css";

const cloudfrontUrl = process.env.REACT_APP_CLOUDFRONT_URL;

export default function selectSticker() {
  return (
    <div className="insta-img-sticker-container">
      <div className="image-renderer-wrapper">
        <div className="img-sticker-icon-container">
          <img className="img-circle-gif" src={`${cloudfrontUrl}/static/green-circle.gif`}></img>
        </div>
        <img className="link-sticker-img" src={`${cloudfrontUrl}/static/ig-step-3.jpeg`} />
      </div>
    </div>
  );
}
